import styled from 'styled-components'
import { Col } from 'react-styled-flexboxgrid-tmp'
import {
  PRIMARY_DARK_COLOR,
} from '@CSSVars/colors'

export const _ListingPreviewCol = styled(Col)`
  position: relative;
  padding: 0 3px;
  width: 20%;
  @media screen and (max-width: 1900px) {
    width: 25%;
  }

  @media screen and (max-width: 1550px) {
    width: 33.3%;
  }

  @media screen and (max-width: 1250px) {
    width: 50%;
  }

  @media screen and (max-width: 580px) {
    width: 100%;
  }
`

export const _CheckBoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 17.07px;
    color:${PRIMARY_DARK_COLOR};
  }
  cursor: pointer;
  margin-bottom: 12px;
  padding: 0 5px;
`
